/** 本文の右に置く、表示中のページの目次。見出しが 2 つ未満なら何も出さない。 */
export function DocsPageToc({
	headings,
	currentIndex,
	onSelect,
}: {
	headings: readonly HTMLHeadingElement[];
	currentIndex: number;
	onSelect: (heading: HTMLHeadingElement) => void;
}) {
	if (headings.length < 2) return null;
	return (
		<aside
			data-testid="docs-page-toc"
			className="sticky top-8 hidden max-h-[calc(100vh-64px)] w-50 shrink-0 flex-col gap-2 overflow-y-auto min-[1200px]:flex"
		>
			<p className="m-0 pl-3.5 text-caption font-semibold text-fg-1">このページの内容</p>
			<div className="flex flex-col">
				{headings.map((heading, i) => (
					<button
						key={i}
						type="button"
						onClick={() => onSelect(heading)}
						className={`cursor-pointer border-l-2 bg-transparent py-1 pr-2 text-left text-caption leading-snug break-words ${heading.tagName === "H3" ? "pl-6" : "pl-3"} ${i === currentIndex ? "border-accent-line text-fg-0" : "border-transparent text-fg-2 hover:text-fg-0"}`}
					>
						{heading.textContent}
					</button>
				))}
			</div>
		</aside>
	);
}
